/*eslint-disable*/
import React, { useState } from 'react';
import { Button, Icon } from 'semantic-ui-react';
import Axios from 'axios';
import { localStorageItems } from "../../utils/constant";

function PdfActionButton(props) {

    const [openBox, setopenBox] = useState(false)

    let customerInvoiceNo = props.data.customerInvoiceNo;
    let customerNo = localStorage.getItem('customerNo')

    let handleGeneratePdf = (e) => {
        const { customerNo, userId, apiToken, customerLogo, customerName, customerCompanyName } = localStorageItems

        const payload = {
            "user_id": userId,
            "customer_no": customerNo,
            "reference_number": props.data.refNo,
            "loginDts": {
                "customerCompanyName": customerCompanyName,
                "customerName": customerName,
                "customerLogo": customerLogo
            }
        }

        Axios.post(`${process.env.REACT_APP_BASE_URL}/sales/sales-invoices/generate-invoice-pdf`, payload, {
            headers: {
                'Content-Type': 'application/json',
                "Access-Control-Allow-Origin": "*",
                'Accept': 'application/json',
                'Authorization': apiToken
            }
        }).then((response => {
            window.open(response?.data?.data?.pfdURL, '_blank');
        }))
            .catch(error => console.log(error))
    }

    return (
        <>
            <a
                onClick={(e) => handleGeneratePdf(e)}
                // href={`${process.env.REACT_APP_SO_PDF_URL}/${customerNo}/${customerInvoiceNo}.pdf`} target="_blank" 
                basic size="mini" icon> <Icon name="file pdf" color="red" /></a>
        </>
    )
}

export default PdfActionButton
